import Amplify from 'aws-amplify'
Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: process.env.VUE_APP_AWS_REGION,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.VUE_APP_COGNITO_USERPOOL_WEB_CLIENT_ID,
    //REQUIRED by Storage - Amazon Cognito Identity Pool ID
    identityPoolId: process.env.VUE_APP_COGNITO_IDENTITY_ID,
  },
  Storage: {
    AWSS3: {
      bucket: '', //REQUIRED -  Amazon S3 bucket
      region: process.env.VUE_APP_AWS_REGION, //OPTIONAL -  Amazon service region
    }
  }
})

export default Amplify